import React from "react";
import { foodBg } from "../../../assets/images";
import { RecipeSelector } from "./RecipeSelector.jsx";
import { TemplateSelector } from "./TemplateSelector.jsx";
import { DownloadButtons } from "./DownloadButtons.jsx";
import { PosterCreatorHeader } from "./PosterCreatorHeader.jsx";
import { ExportLoadingOverlay } from "./ExportLoadingOverlay.jsx";
import { PosterPreviewArea } from "./PosterPreviewArea.jsx";

export function PosterCreatorLayout({
  navigate,
  error,
  downloading,
  recipes,
  loading,
  selectedRecipe,
  setSelectedRecipe,
  selectedTemplate,
  setSelectedTemplate,
  handleDownloadPng,
  handleDownloadPdf,
  posterRef,
  preloadedImageUrl,
  user,
}) {
  return (
    <div className="min-h-screen relative">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-40"
        style={{ backgroundImage: `url(${foodBg})` }}
      />
      <div className="absolute inset-0 bg-slate-900/70" />
      <div className="relative z-10 max-w-5xl mx-auto px-4 py-6 sm:py-8">
        <PosterCreatorHeader onBack={() => navigate("/dashboard")} />

        {error && (
          <div className="mb-6 p-4 bg-red-500/20 border border-red-400/40 rounded-xl text-red-100 text-sm">
            {error}
          </div>
        )}

        <ExportLoadingOverlay show={downloading} />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-4 space-y-6">
            <RecipeSelector
              recipes={recipes}
              loading={loading}
              selectedRecipe={selectedRecipe}
              onSelect={setSelectedRecipe}
            />
            <TemplateSelector
              selectedTemplate={selectedTemplate}
              onSelect={setSelectedTemplate}
            />
            {selectedRecipe && (
              <DownloadButtons
                onDownloadPng={handleDownloadPng}
                onDownloadPdf={handleDownloadPdf}
                downloading={downloading}
              />
            )}
          </div>
          <div className="lg:col-span-8 flex justify-center lg:justify-start lg:items-start">
            <PosterPreviewArea
              selectedRecipe={selectedRecipe}
              loading={loading}
              posterRef={posterRef}
              preloadedImageUrl={preloadedImageUrl}
              selectedTemplate={selectedTemplate}
              user={user}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
